import { useState, useEffect } from 'react'

function ReadIsTouchDevice() {
    if (typeof window === 'undefined') {
        return false
    }
    const hasHover = window.matchMedia('(hover: hover)').matches
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches
    return !hasHover || hasCoarsePointer
}

export const useIsTouchDevice = () => {

    const [isTouchDevice, setIsTouchDevice] = useState(() => ReadIsTouchDevice())

    useEffect(() => {
        const CheckTouchDevice = () => {
            setIsTouchDevice(ReadIsTouchDevice())
        }

        CheckTouchDevice()

        const hoverQuery = window.matchMedia('(hover: hover)')
        const pointerQuery = window.matchMedia('(pointer: coarse)')

        hoverQuery.addEventListener('change', CheckTouchDevice)
        pointerQuery.addEventListener('change', CheckTouchDevice)

        return () => {
            hoverQuery.removeEventListener('change', CheckTouchDevice)
            pointerQuery.removeEventListener('change', CheckTouchDevice)
        }
    }, [])

    return isTouchDevice

}
